import { InputLista, InputNumber, FormLabel, FormError } from '../../../../components/common'
import { OPERATION_MODE } from '@laramie/ui';
import AccordionIcon from '../AccordionIcon'
import { DefinicionAnticipo, DefinicionIntereses, DefinicionQuita } from './components'

const CriteriosFinanciacion = ({ open, toggle, formValues, handleInputProxy, errorOf, params, otherValues, setOtherValues, setPendingChange }) => {
    return <>
        <div className='accordion-header m-top-20'>
            <div className='row'>
                <div className="col-12" onClick={toggle}>
                    <div className='accordion-header-title'>
                        <AccordionIcon {...{open}} />
                        <h3 className={open ? 'active' : ''}>Criterios de financiación</h3>
                    </div>
                </div>
            </div>
        </div>
        {open &&
            <div className='accordion-body'>
                <div className='row form-basic'>
                    <div className="col-12 col-md-6 col-lg-2">
                        <FormLabel htmlFor="periodicidad" required>Periodicidad</FormLabel>
                        <InputNumber
                            name="periodicidad"
                            placeholder=""
                            className={`form-control ${errorOf('periodicidad') ? 'is-invalid' : ''}`}
                            value={formValues.periodicidad} // es un typo en el back
                            onChange={handleInputProxy}
                            precision={0}
                            disabled={params.mode === OPERATION_MODE.VIEW}
                        />
                        <FormError message={errorOf('periodicidad')} />
                    </div>
                    <div className="col-12 col-md-6 col-lg-2">
                        <FormLabel htmlFor="idTipoCalculoInteres" required>Tipo de cálculo</FormLabel>
                        <InputLista
                            name="idTipoCalculoInteres"
                            placeholder=""
                            className={`form-control ${errorOf('idTipoCalculoInteres') ? 'is-invalid' : ''}`}
                            value={formValues.idTipoCalculoInteres}
                            onChange={handleInputProxy}
                            lista="TipoCalculoInteres"
                            disabled={params.mode === OPERATION_MODE.VIEW}
                        />
                        <FormError message={errorOf('idTipoCalculoInteres')} />
                    </div>
                    <div className="col-12 col-md-6 col-lg-2">
                        <FormLabel htmlFor="cuotaDesde" required>Cuotas desde</FormLabel>
                        <InputNumber
                            name="cuotaDesde"
                            placeholder=""
                            className={`form-control ${errorOf('cuotaDesde') ? 'is-invalid' : ''}`}
                            value={formValues.cuotaDesde}
                            onChange={handleInputProxy}
                            precision={0}
                            disabled={params.mode === OPERATION_MODE.VIEW}
                        />
                        <FormError message={errorOf('cuotaDesde')} />
                    </div>
                    <div className="col-12 col-md-6 col-lg-2">
                        <FormLabel htmlFor="cuotaHasta" required>Cuotas hasta</FormLabel>
                        <InputNumber
                            name="cuotaHasta"
                            placeholder=""
                            className={`form-control ${errorOf('cuotaHasta') ? 'is-invalid' : ''}`}
                            value={formValues.cuotaHasta}
                            onChange={handleInputProxy}
                            precision={0}
                            disabled={params.mode === OPERATION_MODE.VIEW}
                        />
                        <FormError message={errorOf('cuotaHasta')} />
                    </div>
                    <div className="col-12 col-md-6 col-lg-2">
                        <label htmlFor="montoCuotaDesde" className="form-label">Monto cuota desde</label>
                        <InputNumber
                            name="montoCuotaDesde"
                            placeholder=""
                            className="form-control"
                            value={formValues.montoCuotaDesde}
                            onChange={handleInputProxy}
                            precision={2}
                            disabled={params.mode === OPERATION_MODE.VIEW}
                        />
                    </div>
                    <div className="col-12 col-md-6 col-lg-2">
                        <label htmlFor="montoCuotaHasta" className="form-label">Monto cuota hasta</label>
                        <InputNumber
                            name="montoCuotaHasta"
                            placeholder=""
                            className="form-control"
                            value={formValues.montoCuotaHasta}
                            onChange={handleInputProxy}
                            precision={2}
                            disabled={params.mode === OPERATION_MODE.VIEW}
                        />
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <FormLabel htmlFor="idTipoCobroAccesorios" required>Tipo cobro accesorios</FormLabel>
                        <InputLista
                            name="idTipoCobroAccesorios"
                            placeholder=""
                            className={`form-control ${errorOf('idTipoCobroAccesorios') ? 'is-invalid' : ''}`}
                            value={formValues.idTipoCobroAccesorios}
                            onChange={handleInputProxy}
                            lista="TipoCobroAccesorios"
                            disabled={params.mode === OPERATION_MODE.VIEW}
                        />
                        <FormError message={errorOf('idTipoCobroAccesorios')} />
                    </div>
                </div>
                <div className='row'>
                    <DefinicionAnticipo
                        {...{params}}
                        data={otherValues.planPagosDefinicionAnticipoCuota}
                        setData={data => setOtherValues(prev => ({...prev, planPagosDefinicionAnticipoCuota: data}))}
                        params={params}
                        setPendingChange={setPendingChange}
                        idTipoCobroAccesorios={formValues.idTipoCobroAccesorios}
                    />
                    <DefinicionIntereses
                        {...{params}}
                        data={otherValues.planPagosDefinicionInteres}
                        setData={data => setOtherValues(prev => ({...prev, planPagosDefinicionInteres: data}))}
                        params={params}
                        setPendingChange={setPendingChange} 
                    />
                    <DefinicionQuita
                        {...{params}}
                        data={otherValues.planPagosDefinicionQuitaCuota}
                        setData={data => setOtherValues(prev => ({...prev, planPagosDefinicionQuitaCuota: data}))}
                        params={params}
                        setPendingChange={setPendingChange}
                    />
                    </div>
            </div>
        }
    </>
}

export default CriteriosFinanciacion
